import { createContext, useContext } from 'react';

export const SelectionContext = createContext(null);

export function useSelection() {
  const ctx = useContext(SelectionContext);
  if (!ctx) throw new Error('useSelection must be used within a SelectionContext.Provider');
  return ctx;
}
